<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom">
        <ion-tab-button tab="dashboard" href="/tabs/dashboard">
          <ion-icon :icon="homeOutline" />
          <ion-label>{{ $t('tabs.dashboard') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="health-records" href="/tabs/health-records">
          <ion-icon :icon="heartOutline" />
          <ion-label>{{ $t('tabs.records') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="add" @click="openQuickAdd">
          <ion-icon :icon="addCircle" class="add-button-icon" />
        </ion-tab-button>

        <ion-tab-button tab="medications" href="/tabs/medications">
          <ion-icon :icon="medkitOutline" />
          <ion-label>{{ $t('tabs.meds') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="settings" href="/tabs/settings">
          <ion-icon :icon="settingsOutline" />
          <ion-label>{{ $t('tabs.settings') }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>

    <!-- Quick Add Action Sheet -->
    <ion-action-sheet
      :is-open="showQuickAdd"
      :header="$t('tabs.quickAdd')"
      :buttons="quickAddButtons"
      @didDismiss="showQuickAdd = false"
    />
  </ion-page>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import {
  IonPage,
  IonTabs,
  IonTabBar,
  IonTabButton,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonActionSheet,
} from '@ionic/vue'
import {
  homeOutline,
  heartOutline,
  addCircle,
  medkitOutline,
  settingsOutline,
  waterOutline,
  fitnessOutline,
  documentTextOutline,
  medicalOutline,
} from 'ionicons/icons'

const router = useRouter()
const { t } = useI18n()
const showQuickAdd = ref(false)

const quickAddButtons = computed(() => [
  {
    text: t('tabs.addHealthRecord'),
    icon: heartOutline,
    handler: () => {
      router.push('/tabs/health-records/add')
    },
  },
  {
    text: t('tabs.addMedication'),
    icon: medkitOutline,
    handler: () => {
      router.push('/tabs/medications/add')
    },
  },
  {
    text: t('tabs.addTestReport'),
    icon: documentTextOutline,
    handler: () => {
      router.push({ name: 'test-reports', query: { action: 'add' } })
    },
  },
  {
    text: t('tabs.addPrescription'),
    icon: medicalOutline,
    handler: () => {
      router.push({ name: 'prescriptions', query: { action: 'add' } })
    },
  },
  {
    text: t('common.cancel'),
    role: 'cancel',
  },
])

function openQuickAdd() {
  showQuickAdd.value = true
}
</script>

<style scoped>
ion-tab-bar {
  padding-bottom: env(safe-area-inset-bottom);
}

ion-tab-button {
  --color: rgba(255, 255, 255, 0.5);
  --color-selected: var(--ion-color-primary);
}

.add-button-icon {
  font-size: 2.5rem;
  color: var(--ion-color-primary);
}

ion-tab-button[tab="add"] {
  --background: transparent;
}
</style>
